// extracted by mini-css-extract-plugin
export var control = "style-module--control--bdb0b";
export var decide = "style-module--decide--aff67";
export var info = "style-module--info--68e9c";
export var innerList = "style-module--inner-list--b35b2";
export var learn = "style-module--learn--e2175";
export var mainList = "style-module--main-list--04877";
export var strat = "style-module--strat--f837e";